// Центральная точка конфигурации адреса бэкенда.
// Меняется через переменную окружения REACT_APP_API_ORIGIN (см. .env),
// по умолчанию — локальный сервер.
export const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN || 'http://localhost:8000';

// Базовый префикс всех REST-эндпоинтов.
export const API_BASE = `${API_ORIGIN}/api`;

// Версия API для эндпоинтов документов/согласования (reports/create, reports/{id},
// approval/{id}). Вынесена в одну константу, чтобы при переходе на следующую версию
// API не искать и не менять "v2" по всем файлам вручную.
export const API_V2_BASE = `${API_BASE}/v2`;
